<template>
  <el-table
    class="common-el-table-styles"
    :height="143"
    :data="blueFlowPackages"
    v-loading="loading"
    @row-click="onBlueFlowPackageChange"
    border
    style="width: 100%"
  >
    <el-table-column width="50">
      <template slot-scope="{ row }">
        <el-radio v-model="selectedBlueFlowPackageId" :label="row.blue_flow_package_id" @change="onBlueFlowPackageChange(row)">
          &ensp;
        </el-radio>
      </template>
    </el-table-column>
    <el-table-column label="蓝海流量包" prop="blue_flow_package_name"></el-table-column>
    <el-table-column label="流量覆盖比例" prop="flow_coverage_ratio"></el-table-column>
    <el-table-column label="预估触达流量（万）" prop="estimated_reach_traffic_range" width="120px"></el-table-column>
    <el-table-column label="预估消耗（元）" prop="estimated_cost_range"></el-table-column>
    <el-table-column label="建议出价（元）" prop="suggested_bid_range"></el-table-column>
  </el-table>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { getBlueFlowPackageList } from '@/api/toutiao.local.model.js'
// eslint-disable-next-line
const props = defineProps({
  value: {
    type: [String, Number]
  },
  accountId: {
    type: [String, Number]
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input', 'change'])
const selectedBlueFlowPackageId = computed({
  get: () => {
    return props.value
  },
  set: (val) => emits('input', val)
})
const blueFlowPackages = ref([])
const loading = ref(false)

watch(
  () => props.accountId,
  (val) => {
    // 第一个账号变化时获取蓝海流量包
    val && getBlueFlowPackages(val)
  },
  { immediate: true }
)

function getBlueFlowPackages(ad_account_id) {
  loading.value = true
  getBlueFlowPackageList({ ad_account_id })
    .then((data) => {
      if (data?.length) {
        blueFlowPackages.value = data.map((i) => ({
          ...i,
          estimated_reach_traffic_range: i.estimated_reach_traffic_range.map((n) => (n / 10000).toFixed(2)).join('~'),
          estimated_cost_range: i.estimated_cost_range.join('~'),
          suggested_bid_range: i.suggested_bid_range.join('~')
        }))
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

function onBlueFlowPackageChange(row) {
  selectedBlueFlowPackageId.value = row.blue_flow_package_id
  emits('change', row)
}
</script>

<style lang="scss" scoped>
</style>
